import React from 'react';
import { faArrowRightFromBracket } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';

const MenuProfile = ({ logout, isOpenMenuProfile, setIsOpenMenuProfile, menuRef, setShouldRedirect }) => {
    const handleLogout = () => {
        setIsOpenMenuProfile(false);

        logout();
    };

    if (!isOpenMenuProfile) return null;

    return (
        <div ref={menuRef} className="tw-absolute tw-top-20 tw-right-0 tw-bg-white tw-shadow-md tw-rounded-none tw-z-50">
            <button
                type="button"
                aria-label="Meu perfil"
                onClick={() => {
                    setShouldRedirect(true)
                }}
                className="tw-flex tw-items-center tw-gap-2 tw-px-6 tw-py-3 tw-w-full hover:tw-bg-gray-100"
            >
                <span>Meu perfil</span>
            </button>
            <button
                type="button"
                aria-label="Sair"
                onClick={handleLogout}
                className="tw-flex tw-items-center tw-gap-2 tw-px-6 tw-py-3 tw-w-full hover:tw-bg-gray-100"
            >
                <span>Sair</span>
                <FontAwesomeIcon icon={faArrowRightFromBracket} color="#777C86" />
            </button>
        </div>
    );
};

MenuProfile.propTypes = exact({
    logout: PropTypes.func.isRequired,
    setIsOpenMenuProfile: PropTypes.func.isRequired,
    isOpenMenuProfile: PropTypes.bool.isRequired,
    menuRef: PropTypes.object,
    setShouldRedirect: PropTypes.func,
});

export default MenuProfile;
